export default "__VITE_ASSET__Dn9Kfb2X__"